import { getLocalStoredData } from "src/utils/_localStorage";
import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from "axios";
import { genericErrorHandler } from "src/utils/_genericErrorHandler";
import { LocalStorageConstants } from "src/constants/_localStorage";

// Create an axios instance
const apiFastifyClient = axios.create({
  baseURL: process.env.REACT_APP_FASTIFY_API_BASE,
});

// Axios interceptor to inject the Language to requests
apiFastifyClient.interceptors.request.use(
  async (request: InternalAxiosRequestConfig) => {
    request.headers["Accept-Language"] = getLocalStoredData(
      LocalStorageConstants.locale
    );

    return request;
  }
);

apiFastifyClient.interceptors.response.use(
  (response: AxiosResponse) => response.data,
  (error: AxiosError) => {
    // Handle errors globally using the provided genericErrorHandler
    genericErrorHandler(error);
    return Promise.reject(error);
  }
);

export default apiFastifyClient;
